import * as React from 'react';
import mergeRefs from "../mergeRefs";
export default function useMergeRefs() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return React.useMemo(function () {
    return mergeRefs.apply(void 0, args);
  }, [].concat(args));
}